<header class="ontario-header" id="ontario-header-default">

      <div class="ontario-row">
       
          <div class="ontario-header__logo-container ontario-columns">
            
              <!--<a href="http://www.ontario.ca" target="_blank">-->
                 
                      <img class="ontario-show-for-medium" src="refresh/assets/images/ontario-logo--desktop.svg"
                           alt-text='-text.GovernmentOfOntario' 
                           alt="{{'-text.GovernmentOfOntario'|translate}}" width="180" height="46"/> 
                           <!--
                      <img class=" ontario-show-for-small-only" src="assets/images/ontario-logo--desktop.svg"
                           alt="Government of Ontario" width="180" height="46">
                           -->
                           
               <!--</a>-->
              
          </div>
          <div class="ontario-header__nav-right-container ontario-columns" [hidden]="!data.subject.showHeader">
                <a (click)="onLangChange()" tabindex="0" (keypress)="keyPress($event)"
                   class="ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline ontario-show-for-medium">

                      <abbr class="ontario-show-mobile" title="{{longName}}">
                          {{shortName}}
                      </abbr>

                      <span class="ontario-show">{{longName}}</span>
                </a>
          </div>
      </div>
  </header>
  <div style="background-color:#006B41; color:white; padding:0.2em 0.7em; font-size:1.3em">
       ServiceOntario
  </div>


<!--

<div class="vision">

   <div class="header2">
      <img src="assets/image/ontario.png" style="width:60%;height: auto;"/>
      <button (click)="onLangChange()" style="float: right; margin: 0.9em 0.8em 0 0; font-size: 0.8em;">{{nextLang}}</button>
   </div>
   
   <div style="width:100%;" class="header3">
      <img src="assets/image/service.ontario.png" style="width:60%;height: auto;"/>
   </div>

   <vision-progress></vision-progress>
</div>
-->